var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Dropdown",
        { attrs: { trigger: "click" }, on: { "on-click": _vm.selectLang } },
        [
          _c(
            "a",
            { attrs: { href: "javascript:void(0)" } },
            [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
              _c("Icon", { attrs: { size: 18, type: "md-arrow-dropdown" } }),
            ],
            1
          ),
          _c(
            "DropdownMenu",
            { attrs: { slot: "list" }, slot: "list" },
            _vm._l(_vm.localList, function (value, key) {
              return _c(
                "DropdownItem",
                { key: `lang-${key}`, attrs: { name: key } },
                [_vm._v(_vm._s(value))]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }